<template>
    <div class="w-100">
        <s-crud title="Deuda de Productores" :filter="filter" searchInput height="68vh" :config="config" :add="false"
            :edit="false" :remove="false" @rowSelected="rowSelected($event)" ref="crudproducerdebt">
            <template v-slot:options>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" text color="white" @click="exportExcel" small :loading="loadingExportMain"
                            class="text-none font-weight-bold">
                            <v-icon>mdi-file-excel</v-icon>
                        </v-btn>
                    </template>
                    <span>Exportar productores con deudas</span>
                </v-tooltip>
            </template>
            <template v-slot:filter>
                <v-container fluid class="pa-0">
                    <v-row dense align="center">
                        <v-col cols="12" class="d-flex align-center py-2">
                            <div class="elegant-switch-container" @click="toggleShowDebtors"
                                :class="{ 'active': filter.ShowDebtors === 1 }">
                                <div class="elegant-switch-icon">
                                    <v-icon size="18" :color="filter.ShowDebtors === 1 ? 'primary' : 'grey darken-1'">
                                        {{ filter.ShowDebtors === 1 ? 'mdi-account-cash' : 'mdi-account-cash-outline' }}
                                    </v-icon>
                                </div>
                                <div class="elegant-switch-text">
                                    <span class="elegant-switch-label">PRODUCTORES CON DEUDA</span>
                                    <!-- <span class="elegant-switch-status">
                                        {{ filter.ShowDebtors === 1 ? 'Activo' : 'Inactivo' }}
                                    </span> -->
                                </div>
                                <div class="elegant-switch-toggle">
                                    <div class="elegant-switch-knob"></div>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </template>

            <template v-slot:[`item.CardName`]="{ item }">
                <div class="d-flex flex-column py-1 align-start">
                    <span :class="getTypeDebtClass(item.TypeDebt)">
                        {{ item.CardCode }}
                    </span>
                    <span class="text-subtitle-2 font-weight-medium grey--text text--darken-4">
                        {{ item.CardName }}
                    </span>
                </div>
            </template>

            <template v-slot:[`item.BalanceME`]="{ item }">
                <span class="font-weight-bold grey--text text--darken-3">
                    {{ formatUSD(item.BalanceME) }}
                </span>
            </template>

            <template v-slot:[`item.BalanceML`]="{ item }">
                <span class="font-weight-bold grey--text text--darken-3">
                    {{ formatPEN(item.BalanceML) }}
                </span>
            </template>

            <template v-slot:[`item.TypeDebt`]="{ item }">
                <div class="d-flex justify-center align-center">
                    <span :class="getTypeDebtClass(item.TypeDebt)">
                        {{ item.TypeDebt || 'N/A' }}
                    </span>
                </div>
            </template>

            <template v-slot:[`item.Options`]="{ item }">
                <div class="d-flex justify-center align-center">
                    <v-btn small depressed color="primary" class="text-none font-weight-medium rounded-lg"
                        @click.stop="openDetailsModal(item)">
                        Detalle
                    </v-btn>
                    <v-btn small depressed color="info" class="rounded-lg ml-1"
                        style="min-width: 32px; width: 32px; padding: 0;" @click.stop="openHistoryModal(item)"
                        title="Ver Histórico del Productor">
                        <v-icon small>mdi-history</v-icon>
                    </v-btn>
                    <v-btn small depressed color="success" class="rounded-lg ml-1"
                        style="min-width: 32px; width: 32px; padding: 0;" @click.stop="exportDirectExcel(item)"
                        title="Exportar Detalle a Excel">
                        <v-icon small>mdi-file-excel</v-icon>
                    </v-btn>
                    <v-btn small depressed color="warning" class="rounded-lg ml-1"
                        style="min-width: 32px; width: 32px; padding: 0;" @click.stop="exportHistoryExcel(item)"
                        title="Exportar Historial Consolidado por Semana a Excel">
                        <v-icon small>mdi-file-clock</v-icon>
                    </v-btn>
                </div>
            </template>
        </s-crud>

        <v-dialog v-model="detailsModalVisible" max-width="1300px" scrollable>
            <v-card class="rounded-xl overflow-hidden">
                <v-card-title class="primary d-flex align-center px-4 py-2 white--text"
                    style="border-bottom: 1px solid rgba(0, 0, 0, 0.12);">
                    <div>
                        <span class="text-h6 font-weight-bold d-block white--text" style="line-height: 1.2;">
                            Detalle de Deuda
                        </span>
                        <span class="text-caption mt-1 d-inline-block white--text" style="opacity: 0.85;"
                            v-if="selectedProducer">
                            <span class="font-weight-bold white--text">
                                {{ selectedProducer.CardCode }} - {{ selectedProducer.CardName }}
                            </span>
                        </span>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="detailsModalVisible = false" dark
                        style="background-color: rgba(255, 255, 255, 0.15) !important;">
                        <v-icon size="18">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-0" style="background-color: #ffffff;">
                    <!-- <div class="pa-3"
                        style="background-color: #f8f9fa; border-bottom: 1px solid #e4e4e7; display: grid; grid-template-columns: repeat(2, minmax(170px, 200px)); gap: 8px; justify-content: start;">
                        <div class="summary-cardbox border rounded-2xl shadow-sm pa-3"
                            style="background-color: #ffffff; border: 1px solid #e4e4e7 !important; border-radius: 16px !important; box-shadow: 0 1px 3px rgba(0,0,0,0.05) !important;">
                            <div class="d-flex align-center justify-space-between mb-1">
                                <span class="type-debt-badge-magenta">ANTICIPOS</span>
                                <v-icon color="pink darken-2" small>mdi-cash-refund</v-icon>
                            </div>
                            <div class="text-caption font-weight-medium grey--text text--darken-2 mb-1"
                                style="font-size: 11px !important;">
                                {{ anticipoTotals.cardCode }}
                            </div>
                            <div class="text-h5 font-weight-black font-mono" :class="getAmountClass(anticipoTotals.ml)">
                                {{ formatPEN(anticipoTotals.ml) }}
                            </div>
                        </div>

                        <div class="summary-cardbox border rounded-2xl shadow-sm pa-3"
                            style="background-color: #ffffff; border: 1px solid #e4e4e7 !important; border-radius: 16px !important; box-shadow: 0 1px 3px rgba(0,0,0,0.05) !important;">
                            <div class="d-flex align-center justify-space-between mb-1">
                                <span class="type-debt-badge-green">INSUMOS</span>
                                <v-icon color="green darken-3" small>mdi-package-variant-closed</v-icon>
                            </div>
                            <div class="text-caption font-weight-medium grey--text text--darken-2 mb-1"
                                style="font-size: 11px !important;">
                                {{ insumoTotals.cardCode }}
                            </div>
                            <div class="text-h5 font-weight-black font-mono" :class="getAmountClass(insumoTotals.ml)">
                                {{ formatPEN(insumoTotals.ml) }}
                            </div>
                        </div>
                    </div> -->

                    <!-- Modern Shaded 3D Cylinder Bar Dashboard Section -->
                    <div class="pa-3 border-b" style="background-color: #fafafa; border-bottom: 1px solid #e4e4e7;">
                        <!-- <h3 class="text-subtitle-2 font-weight-bold grey--text text--darken-3 mb-4 d-flex align-center">
                            <v-icon class="mr-2" color="primary" small>mdi-chart-timeline-variant</v-icon>
                            Resumen de Comparativa Histórica por Año
                        </h3>

                        <div v-if="yearlyGroups.length === 0" class="text-caption grey--text text-center py-4">
                            No hay información histórica registrada.
                        </div> -->

                        <div v-if="yearlyGroups" ref="scrollContainer" class="dashboard-3d-row" @mousedown="startDrag"
                            @mouseleave="stopDrag" @mouseup="stopDrag" @mousemove="onDrag" @touchstart="startDrag"
                            @touchend="stopDrag" @touchmove="onDrag" :class="{ 'dragging': isDragging }">
                            <div v-for="(group, idx) in yearlyGroups" :key="idx" class="dashboard-3d-card pa-2">
                                <div class="d-flex justify-space-between align-center">
                                    <span class="dashboard-year-badge font-mono">{{ group.year }}</span>
                                    <div class="text-right">
                                        <span class="text-caption grey--text font-weight-medium"
                                            style="font-size: 10px !important;">Total</span>
                                        <div
                                            class="text-subtitle-2 font-weight-black blue--text text--darken-3 font-mono">
                                            {{ formatPEN(group.anticipoTotal + group.insumoTotal) }}
                                        </div>
                                    </div>
                                </div>

                                <div class="chart-bar-area">
                                    <div class="chart-canvas-container">
                                        <canvas :id="'chart-year-' + group.year"></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <v-data-table :headers="detailHeaders" :items="detailData" :items-per-page="25"
                        class="elevation-0 shadcn-modal-table" dense fixed-header height="360px" :footer-props="{
                            'items-per-page-options': [10, 15, 25],
                            'items-per-page-text': 'Filas por página:'
                        }" no-data-text="No hay movimientos registrados para este productor.">
                        <template v-slot:[`item.AccountingDate`]="{ item }">
                            <span class="text-caption grey--text text--darken-3 font-weight-medium">
                                {{ formatDate(item.AccountingDate) }}
                            </span>
                        </template>

                        <template v-slot:[`item.DocumentType`]="{ item }">
                            <span class="doc-type-badge">
                                {{ item.DocumentType }}
                            </span>
                        </template>

                        <template v-slot:[`item.Glosa`]="{ item }">
                            <div class="text-caption text-truncate grey--text text--darken-2" style="max-width: 280px;"
                                :title="item.Glosa">
                                {{ item.Glosa }}
                            </div>
                        </template>

                        <template v-slot:[`item.AmountME`]="{ item }">
                            <span :class="getAmountClass(item.AmountME)" class="font-weight-bold font-mono">
                                {{ formatUSD(item.AmountME) }}
                            </span>
                        </template>


                        <!-- C/D ML -->
                        <template v-slot:[`item.AmountML`]="{ item }">
                            <span :class="getAmountClass(item.AmountML)" class="font-weight-bold font-mono">
                                {{ formatPEN(item.AmountML) }}
                            </span>
                        </template>

                        <template v-slot:[`item.TypeDebt`]="{ item }">
                            <span :class="getTypeDebtClass(item.TypeDebt)">
                                {{ item.TypeDebt }}
                            </span>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-card-actions class="px-6 py-3 grey lighten-5 justify-end" style="border-top: 1px solid #e4e4e7;">
                    <v-btn depressed color="success" class="text-none font-weight-medium rounded-lg px-4"
                        @click="exportExcelDetail" :disabled="!detailData || detailData.length === 0">
                        <v-icon left small>mdi-file-excel</v-icon>
                        Exportar Excel
                    </v-btn>
                    <v-btn depressed color="error" class="text-none font-weight-medium rounded-lg px-4"
                        @click="detailsModalVisible = false">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dynamic History Records Modal (Anticipos / Insumos) -->
        <v-dialog v-model="historyModalVisible" max-width="1300px" scrollable>
            <v-card class="rounded-xl overflow-hidden">
                <v-card-title class="primary d-flex align-center px-4 py-2 white--text"
                    style="border-bottom: 1px solid rgba(0, 0, 0, 0.12);">
                    <div>
                        <span class="text-h6 font-weight-bold d-block white--text" style="line-height: 1.2;">
                            Histórico de {{ isAdvanceType ? 'Anticipos (PP)' : 'Insumos (CP)' }}
                        </span>
                        <span class="text-caption mt-1 d-inline-block white--text" style="opacity: 0.85;"
                            v-if="selectedProducer">
                            <span class="font-weight-bold white--text">
                                {{ selectedProducer.CardCode }} - {{ selectedProducer.CardName }}
                            </span>
                        </span>
                    </div>
                    <v-spacer></v-spacer>
                    <v-progress-circular indeterminate size="20" width="2" color="white" class="mr-3"
                        v-if="loadingHistory"></v-progress-circular>
                    <v-btn icon small @click="historyModalVisible = false" dark
                        style="background-color: rgba(255, 255, 255, 0.15) !important;">
                        <v-icon size="18">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-0">
                    <v-card class="elevation-0 border rounded-xl overflow-hidden bg-white">
                        <v-card-title class="px-3 py-2.5 d-flex align-center bg-slate-50"
                            style="border-bottom: 1px solid #e2e8f0; background-color: #f8fafc;">
                            <div class="d-flex align-center">
                                <div class="header-icon-container mr-2 d-flex align-center justify-center rounded-lg"
                                    :class="isAdvanceType ? 'bg-amber-light' : 'bg-emerald-light'">
                                    <v-icon size="18" :color="isAdvanceType ? 'amber darken-3' : 'teal darken-2'">
                                        {{ isAdvanceType ? 'mdi-cash-fast' : 'mdi-package-variant-closed' }}
                                    </v-icon>
                                </div>
                                <div>
                                    <span class="text-subtitle-2 font-weight-bold text-slate-800 d-block"
                                        style="line-height: 1.2;">
                                        {{ isAdvanceType ? 'Histórico de Anticipos' : 'Histórico de Insumos' }}
                                    </span>
                                    <span class="text-caption text-slate-500">
                                        {{ isAdvanceType
                                            ? 'Registro histórico de adelantos del productor'
                                            : 'Registro histórico de consumos del productor'
                                        }}
                                    </span>
                                </div>
                            </div>
                            <v-spacer></v-spacer>
                            <span :class="isAdvanceType ? 'type-debt-badge-magenta' : 'type-debt-badge-green'"
                                class="mr-3 font-mono font-weight-bold">
                                {{ isAdvanceType ? 'ANTICIPOS (PP)' : 'INSUMOS (CP)' }}
                            </span>
                        </v-card-title>

                        <v-data-table :headers="historyHeaders" :items="historyData" :items-per-page="15"
                            class="elevation-0 tailwind-styled-table" dense fixed-header height="520px"
                            no-data-text="No hay registros históricos para este proveedor." :footer-props="{
                                'items-per-page-options': [15, 25, 50, -1],
                                'items-per-page-text': 'Filas por página:'
                            }">

                            <template v-slot:[`item.AccountingDate`]="{ item }">
                                <span class="text-caption font-weight-medium font-mono text-slate-700">
                                    {{ $fun.formatDateView(item.AccountingDate) }}
                                </span>
                            </template>

                            <template v-slot:[`item.DueDate`]="{ item }">
                                <span class="text-caption font-mono text-slate-600">
                                    {{ $fun.formatDateView(item.DueDate) }}
                                </span>
                            </template>

                            <template v-slot:[`item.TaxDate`]="{ item }">
                                <span class="text-caption font-mono text-slate-600">
                                    {{ $fun.formatDateView(item.TaxDate) }}
                                </span>
                            </template>

                            <template v-slot:[`item.TypeDocumentName`]="{ item }">
                                <span class="doc-type-pill">
                                    {{ item.TypeDocumentName || '-' }}
                                </span>
                            </template>

                            <template v-slot:[`item.Glosa`]="{ item }">
                                <div class="text-caption text-truncate text-slate-600" style="max-width: 250px;"
                                    :title="item.Glosa">
                                    {{ item.Glosa || '-' }}
                                </div>
                            </template>

                            <template v-slot:[`item.DocRate`]="{ item }">
                                <span class="font-mono text-caption text-slate-600">
                                    {{ (item.DocRate !== undefined && item.DocRate !== null) ?
                                        parseFloat(item.DocRate).toFixed(4) : '-' }}
                                </span>
                            </template>

                            <!-- C/D ML -->
                            <template v-slot:[`item.AmountML`]="{ item }">
                                <span class="font-weight-bold font-mono text-caption"
                                    :class="{ 'text-green': item.DebitCreditMS == 'C' }">
                                    {{ formatPEN(item.DebitCreditMS == 'C' ? item.CreditML : item.DebitML) }}
                                </span>
                            </template>

                            <!-- Saldo Acum. ML -->
                            <template v-slot:[`item.AccumulatedBalanceML`]="{ item }">
                                <span class="font-mono text-caption text-slate-700">
                                    {{ formatPEN(item.AccumulatedBalanceML) }}
                                </span>
                            </template>

                            <!-- C/D MEST -->
                            <template v-slot:[`item.AmountME`]="{ item }">
                                <span class="font-weight-bold font-mono text-caption"
                                    :class="{ 'text-green': item.DebitCreditMS == 'C' }">
                                    {{ formatUSD(item.DebitCreditMS == 'C' ? item.CreditMS : item.DebitMS) }}
                                </span>
                            </template>

                            <!-- Saldo Acum. MEST -->
                            <template v-slot:[`item.AccumulatedBalanceMS`]="{ item }">
                                <span class="font-weight-bold font-mono text-caption">
                                    {{ formatUSD(item.AccumulatedBalanceMS) }}
                                </span>
                            </template>

                            <!-- C/D ME -->
                            <template v-slot:[`item.DebitCreditME`]="{ item }">
                                <span class="font-weight-bold font-mono text-caption" v-if="item.DebitCreditME"
                                    :class="{ 'text-green': item.DebitCreditMS == 'C' }">
                                    {{ formatUSD(item.DebitCreditMS == 'C' ? item.CreditMS : item.DebitMS) }}
                                </span>
                            </template>

                            <!-- Saldo Acumulado (ME) -->
                            <template v-slot:[`item.AccumulatedBalanceME`]="{ item }">
                                <span class="font-mono text-caption text-slate-700">
                                    {{ formatUSD(item.AccumulatedBalanceME) }}
                                </span>
                            </template>

                            <!-- Crédito (ME) -->
                            <template v-slot:[`item.CreditME`]="{ item }">
                                <span class="font-weight-bold font-mono text-caption" v-if="item.CreditME > 0">
                                    {{ formatUSD(item.CreditME) }}
                                </span>
                            </template>

                            <!-- CARGO (ML) -->
                            <template v-slot:[`item.DebitML`]="{ item }">
                                <span class="font-weight-bold font-mono text-caption" v-if="item.DebitCreditMS == 'D'">
                                    {{ formatPEN(item.DebitML) }}
                                </span>
                            </template>

                            <!-- Abono (ML) -->
                            <template v-slot:[`item.CreditML`]="{ item }">
                                <span class="font-weight-bold font-mono text-caption" v-if="item.DebitCreditMS == 'C'">
                                    {{ formatPEN(item.CreditML) }}
                                </span>
                            </template>

                            <!-- Debito MS -->
                            <template v-slot:[`item.DebitMS`]="{ item }">
                                <span class="font-weight-bold font-mono text-caption" v-if="item.DebitCreditMS == 'D'">
                                    {{ formatUSD(item.DebitMS) }}
                                </span>
                            </template>

                            <!-- Crédito MS -->
                            <template v-slot:[`item.CreditMS`]="{ item }">
                                <span class="font-weight-bold font-mono text-caption" v-if="item.DebitCreditMS == 'C'">
                                    {{ formatUSD(item.CreditMS) }}
                                </span>
                            </template>

                            <!-- <template v-slot:[`item.AmountReconciled`]="{ item }">
                                <span class="font-mono text-caption text-slate-700">
                                    {{ item.CurrencyName === 'US$' ? formatUSD(item.AmountReconciled) :
                                        formatPEN(item.AmountReconciled) }}
                                </span>
                            </template> -->

                            <!-- <template v-slot:[`item.AmountPending`]="{ item }">
                                <span class="font-weight-black font-mono text-caption">
                                    {{ item.CurrencyName === 'US$' ? formatUSD(item.AmountPending) :
                                        formatPEN(item.AmountPending) }}
                                </span>
                            </template> -->
                        </v-data-table>
                    </v-card>
                </v-card-text>
            </v-card>
        </v-dialog>

        <AlertSunshine :dialog="loadingCalculate" text="CARGANDO" />
    </div>
</template>

<script>
import _TasProducerDebtReportService from "@/services/Technicalassistance/TasProducerDebtReport.js";
import _TasProducerHistoryRecordService from "@/services/Technicalassistance/TasProducerHistoryRecord.js";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Chart from "chart.js/auto";

export default {
    name: "TasProducerDebtReport",
    data: () => ({
        filter: {
            ShowDebtors: 1,
        },
        selectedProducer: null,
        yearlyChartInstances: {},
        config: {
            model: {
                CardCode: "ID",
                CardName: "string",
                TypeDebt: "string",
                TotalAmountME: "decimal",
                TotalAmountML: "decimal",
                Options: ""
            },
            service: _TasProducerDebtReportService,
            headers: [
                { text: "PROVEEDOR", value: "CardName", },
                { text: "GRUPO", value: "GroupName", width: 120, align: 'center' },
                { text: "TIPO", value: "CardTypeName", width: 100, align: 'center' },
                // { text: "TIPO DEUDA", value: "TypeDebt", width: 100, align: 'center' },
                { text: "TOTAL (USD)", value: "BalanceME", align: 'right', width: 130 },
                { text: "TOTAL (SOLES)", value: "BalanceML", align: 'right', width: 130 },
                { text: "Opciones", value: "Options", width: 200, align: 'center' },
            ],
        },
        item: null,
        selected: [],
        loadingCalculate: false,
        loadingExportMain: false,
        isDragging: false,
        startX: 0,
        scrollLeft: 0,
        detailsModalVisible: false,
        historyModalVisible: false,
        detailData: [],
        detailHeaders: [
            { text: "Fecha", value: "AccountingDate", width: 100, align: 'center', sortable: false },
            { text: "Tipo Documento", value: "DocumentType", width: 120, align: 'center', sortable: false },
            { text: "Glosa / Concepto", value: "Glosa", sortable: false },
            { text: "Saldo (USD)", value: "AmountME", align: 'right', width: 100, sortable: false },
            { text: "Saldo (SOLES)", value: "AmountML", align: 'right', width: 100, sortable: false },
            { text: "Tipo Deuda", value: "TypeDebt", align: 'center', width: 100, sortable: false },
        ],
        historyData: [],
        loadingHistory: false,
        isAdvanceType: false,
        historyHeaders: [
            { text: 'Fecha Conta.', value: 'AccountingDate', align: 'center', sortable: false },
            // { text: 'Fecha Venc.', value: 'DueDate', align: 'center', sortable: false },
            // { text: 'Fecha Documento', value: 'TaxDate', align: 'center', sortable: false },
            // { text: 'Código Cuenta', value: 'AccountCode', align: 'start', sortable: false },
            // { text: 'Nombre Cuenta', value: 'AccountName', align: 'start', sortable: false },
            // { text: 'Código Productor', value: 'CardCode', align: 'start', sortable: false },
            // { text: 'Nombre Productor', value: 'CardName', align: 'start', sortable: false },
            // { text: 'Transacción ID', value: 'TransactionID', align: 'center', sortable: false },
            // { text: 'Tipo Documento', value: 'TypeDocumentName', align: 'start', sortable: false },
            // { text: 'Doc. Origen', value: 'DocNumOrigin', align: 'center', sortable: false },
            // { text: 'Referencia 1', value: 'Reference1', align: 'start', sortable: false },
            // { text: 'Referencia 2', value: 'Reference2', align: 'start', sortable: false },
            { text: 'Glosa', value: 'Glosa', align: 'start', sortable: false },
            { text: 'T.C', value: 'DocRate', align: 'right', sortable: false },
            { text: 'Moneda', value: 'CurrencyName', align: 'center', sortable: false },
            // { text: 'Debito/Credito', value: 'DebitCreditMS', align: 'center', sortable: false },
            { text: 'C/D ML', value: 'AmountML', align: 'right', width: 100, sortable: false },
            { text: 'Saldo Acum. ML', value: 'AccumulatedBalanceML', width: 120, align: 'right', sortable: false },
            { text: 'C/D MEST', value: 'AmountME', align: 'right', width: 100, sortable: false },
            { text: 'Saldo Acum. MEST', value: 'AccumulatedBalanceMS', width: 120, align: 'right', sortable: false },
            { text: 'C/D ME', value: 'DebitCreditME', align: 'right', width: 100, sortable: false },
            { text: 'Saldo Acum. ME', value: 'AccumulatedBalanceME', width: 120, align: 'right', sortable: false },
            { text: 'Crédito (ME)', value: 'CreditME', align: 'right', width: 100, sortable: false },
            { text: 'Cargo (ML)', value: 'DebitML', align: 'right', width: 100, sortable: false },
            { text: 'Abono (ML)', value: 'CreditML', align: 'right', width: 100, sortable: false },
            { text: 'Débito (MS)', value: 'DebitMS', align: 'right', width: 100, sortable: false },
            { text: 'Crédito (MS)', value: 'CreditMS', align: 'right', width: 100, sortable: false },
            // { text: 'Monto Reconciliado', value: 'AmountReconciled', align: 'right', width: 120, sortable: false },
            // { text: 'Saldo Pendiente', value: 'AmountPending', align: 'right', width: 120, sortable: false }
        ],
        detailsModalVisible: false,
    }),
    computed: {
        anticipoTotals() {
            let totalML = 0;
            let totalME = 0;
            let cardCode = '';
            if (this.detailData && this.detailData.length > 0) {
                this.detailData.forEach(item => {
                    const type = (item.TypeDebt || '').toUpperCase();
                    if (type.includes('ANTICIPO')) {
                        totalML += Math.abs(parseFloat(item.AmountML || 0));
                        totalME += Math.abs(parseFloat(item.AmountME || 0));
                        if (!cardCode) {
                            cardCode = item.CardCode;
                        }
                    }
                });
            }
            return { ml: totalML, me: totalME, cardCode: cardCode };
        },
        insumoTotals() {
            let totalML = 0;
            let totalME = 0;
            let cardCode = '';
            if (this.detailData && this.detailData.length > 0) {
                this.detailData.forEach(item => {
                    const type = (item.TypeDebt || '').toUpperCase();
                    if (type.includes('INSUMO')) {
                        totalML += Math.abs(parseFloat(item.AmountML || 0));
                        totalME += Math.abs(parseFloat(item.AmountME || 0));
                        if (!cardCode) {
                            cardCode = item.CardCode;
                        }
                    }
                });
            }
            return { ml: totalML, me: totalME, cardCode: cardCode };
        },
        yearlyGroups() {
            const groups = {};
            if (this.detailData && this.detailData.length > 0) {
                this.detailData.forEach(item => {
                    const year = item.AccountingDate ? item.AccountingDate.substring(0, 4) : 'Sin Año';
                    const type = (item.TypeDebt || '').toUpperCase();
                    const amount = Math.abs(parseFloat(item.AmountML || 0));

                    if (!groups[year]) {
                        groups[year] = {
                            year,
                            anticipoTotal: 0,
                            insumoTotal: 0,
                            hasAnticipo: false,
                            hasInsumo: false
                        };
                    }

                    if (type.includes('ANTICIPO')) {
                        groups[year].anticipoTotal += amount;
                        groups[year].hasAnticipo = true;
                    } else if (type.includes('INSUMO')) {
                        groups[year].insumoTotal += amount;
                        groups[year].hasInsumo = true;
                    }
                });
            }
            return Object.values(groups).sort((a, b) => b.year.localeCompare(a.year));
        },
        maxYearlyTotal() {
            let maxVal = 0;
            if (this.yearlyGroups && this.yearlyGroups.length > 0) {
                this.yearlyGroups.forEach(g => {
                    if (g.anticipoTotal > maxVal) maxVal = g.anticipoTotal;
                    if (g.insumoTotal > maxVal) maxVal = g.insumoTotal;
                });
            }
            return maxVal || 1;
        }
    },
    watch: {
        detailsModalVisible(newVal) {
            if (newVal) {
                this.renderYearlyCharts();
            }
        },
        detailData(newVal) {
            if (newVal && newVal.length > 0) {
                this.renderYearlyCharts();
            }
        }
    },
    beforeDestroy() {
        if (this.yearlyChartInstances) {
            Object.values(this.yearlyChartInstances).forEach(instance => {
                if (instance) instance.destroy();
            });
        }
    },
    methods: {
        rowSelected(item) {
            if (item && item.length > 0) {
                this.selected = item;
                this.item = { ...item[0] }
                console.log(JSON.parse(JSON.stringify(this.item)))
            } else {
                this.selected = [];
                this.item = null;
            }
        },
        renderYearlyCharts() {
            // Destroy previous instances first
            if (this.yearlyChartInstances) {
                Object.values(this.yearlyChartInstances).forEach(instance => {
                    if (instance) instance.destroy();
                });
            }
            this.yearlyChartInstances = {};

            this.$nextTick(() => {
                if (this.yearlyGroups && this.yearlyGroups.length > 0) {
                    this.yearlyGroups.forEach(group => {
                        const canvasId = `chart-year-${group.year}`;
                        const canvas = document.getElementById(canvasId);
                        if (!canvas) return;

                        // Forcefully destroy any chart instance associated with this canvas
                        const existingChart = Chart.getChart(canvas);
                        if (existingChart) {
                            existingChart.destroy();
                        }

                        const ctx = canvas.getContext('2d');

                        // Create beautiful vertical gradients
                        const gradientAnticipo = ctx.createLinearGradient(0, 0, 0, 120);
                        gradientAnticipo.addColorStop(0, '#e879f9');
                        gradientAnticipo.addColorStop(1, '#be185d');

                        const gradientInsumo = ctx.createLinearGradient(0, 0, 0, 120);
                        gradientInsumo.addColorStop(0, '#34d399');
                        gradientInsumo.addColorStop(1, '#059669');

                        this.yearlyChartInstances[group.year] = new Chart(ctx, {
                            type: 'bar',
                            data: {
                                labels: ['Anticipos', 'Insumos'],
                                datasets: [{
                                    data: [group.anticipoTotal, group.insumoTotal],
                                    backgroundColor: [gradientAnticipo, gradientInsumo],
                                    borderColor: ['#be185d', '#059669'],
                                    borderWidth: 1.5,
                                    borderRadius: 6,
                                    barThickness: 24,
                                }]
                            },
                            plugins: [
                                {
                                    id: 'customDataLabels',
                                    afterDatasetsDraw: (chart) => {
                                        const { ctx } = chart;
                                        ctx.save();
                                        ctx.font = 'bold 9px sans-serif';
                                        ctx.textAlign = 'center';
                                        ctx.textBaseline = 'bottom';
                                        ctx.fillStyle = '#475569'; // slate-600

                                        chart.data.datasets.forEach((dataset, i) => {
                                            const meta = chart.getDatasetMeta(i);
                                            meta.data.forEach((bar, index) => {
                                                const val = dataset.data[index];
                                                if (val > 0) {
                                                    const formatted = this.formatPEN(val);
                                                    ctx.fillText(formatted, bar.x, bar.y - 4);
                                                }
                                            });
                                        });
                                        ctx.restore();
                                    }
                                }
                            ],
                            options: {
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                    legend: {
                                        display: false
                                    },
                                    title: {
                                        display: false
                                    },
                                    tooltip: {
                                        backgroundColor: 'rgba(15, 23, 42, 0.95)',
                                        titleFont: { size: 10, weight: 'bold' },
                                        bodyFont: { size: 11, family: 'monospace' },
                                        padding: 8,
                                        cornerRadius: 6,
                                        displayColors: false,
                                        callbacks: {
                                            label: (context) => {
                                                return `Monto: ${this.formatPEN(context.raw)}`;
                                            }
                                        }
                                    }
                                },
                                scales: {
                                    y: {
                                        display: true,
                                        grid: {
                                            display: true,
                                            color: '#f1f5f9',
                                            drawBorder: false
                                        },
                                        ticks: {
                                            color: '#94a3b8',
                                            font: { size: 8 },
                                            callback: (value) => {
                                                return this.formatPEN(value);
                                            }
                                        },
                                        max: this.maxYearlyTotal * 1.15
                                    },
                                    x: {
                                        grid: { display: false },
                                        ticks: {
                                            color: '#64748b',
                                            font: { size: 10, weight: '600' }
                                        }
                                    }
                                }
                            }
                        });
                    });
                }
            });
        },
        getBarHeightPercent(amount) {
            const max = this.maxYearlyTotal;
            const pct = (amount / max) * 100;
            return `${Math.max(5, Math.min(100, pct))}%`;
        },
        openDetailsModal(item) {
            this.selectedProducer = item;
            const params = {
                CardCode: item.CardCode.substring(1),
                TaxDate: new Date().toISOString().split('T')[0],
            }
            console.log(JSON.parse(JSON.stringify(params)))
            this.loadingCalculate = true;
            _TasProducerDebtReportService.detail(params, this.$fun.getUserID()).then((result) => {
                if (result.status == 200) {
                    console.log(JSON.parse(JSON.stringify(result.data)))
                    this.detailData = result.data;
                }
                this.detailsModalVisible = true;
            }).catch((err) => {
                console.error(err);
                this.$fun.alert("Ocurrió un error al cargar el detalle de deudas.", "error");
            }).finally(() => {
                this.loadingCalculate = false;
            });
        },
        openHistoryModal(item) {
            this.selectedProducer = item;
            this.historyModalVisible = true;
            this.fetchProducerHistory(item.CardCode);
        },
        async fetchProducerHistory(CardCode) {
            this.loadingHistory = true;
            this.historyData = [];
            try {
                this.isAdvanceType = CardCode.startsWith("PP");
                const params = {
                    filter: { CardCode },
                    draw: 1,
                    start: 0,
                    length: -1,
                    // order: [{ dir: "asc", column: "" }],
                    searchText: ""
                };
                console.log(JSON.parse(JSON.stringify({ params })));

                let response;
                if (this.isAdvanceType) {
                    response = await _TasProducerHistoryRecordService.paginationAdvanceMoney(params, this.$fun.getUserID());
                } else {
                    response = await _TasProducerHistoryRecordService.paginationAdvanceSupplies(params, this.$fun.getUserID());
                }

                if (response && response.status === 200 && response.data) {
                    if (Array.isArray(response.data.data)) {
                        this.historyData = response.data.data;
                    } else if (Array.isArray(response.data)) {
                        this.historyData = response.data;
                    }
                }
            } catch (error) {
                console.error("Error fetching producer history:", error);
                this.$fun.alert("Error al cargar el histórico del productor.", "error");
            } finally {
                this.loadingHistory = false;
            }
        },
        formatUSD(value) {
            if (value === null || value === undefined || value === "") return '$ 0.00';
            const num = parseFloat(value);
            if (isNaN(num)) return '$ 0.00';
            return '$ ' + num.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        formatPEN(value) {
            if (value === null || value === undefined || value === "") return 'S/ 0.00';
            const num = parseFloat(value);
            if (isNaN(num)) return 'S/ 0.00';
            return 'S/ ' + num.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        formatDate(value) {
            if (!value) return "";
            return this.$moment(value).format("DD/MM/YYYY");
        },
        getDocumentTypeColor(type) {
            if (!type) return 'grey lighten-4';
            const t = type.toUpperCase();
            if (t.includes('PAGO') || t.includes('COBRO')) return 'green lighten-5';
            if (t.includes('FACTURA')) return 'blue lighten-5';
            if (t.includes('ANTICIPO') || t.includes('ADELANTO')) return 'amber lighten-5';
            return 'grey lighten-4';
        },
        getDocumentTypeClass(type) {
            if (!type) return 'grey--text text--darken-2';
            const t = type.toUpperCase();
            if (t.includes('PAGO') || t.includes('COBRO')) return 'green--text text--darken-4';
            if (t.includes('FACTURA')) return 'blue--text text--darken-4';
            if (t.includes('ANTICIPO') || t.includes('ADELANTO')) return 'amber--text text--darken-4';
            return 'grey--text text--darken-2';
        },
        getAmountClass(val) {
            const num = parseFloat(val);
            if (isNaN(num) || num === 0) return 'grey--text text--darken-1';
            return num < 0 ? 'red--text text--darken-3' : 'green--text text--darken-3';
        },
        getTypeDebtClass(type) {
            if (!type) return 'type-debt-badge-gray';
            const t = type.toUpperCase();
            if (t.includes('ANTICIPO')) return 'type-debt-badge-magenta';
            if (t.includes('INSUMO')) return 'type-debt-badge-green';
            return 'type-debt-badge-gray';
        },
        toggleShowDebtors() {
            this.filter.ShowDebtors = this.filter.ShowDebtors === 1 ? 0 : 1;
        },
        startDrag(e) {
            this.isDragging = true;
            const clientX = e.pageX || (e.touches && e.touches[0] ? e.touches[0].pageX : 0);
            this.startX = clientX - this.$refs.scrollContainer.offsetLeft;
            this.scrollLeft = this.$refs.scrollContainer.scrollLeft;
        },
        stopDrag() {
            this.isDragging = false;
        },
        onDrag(e) {
            if (!this.isDragging) return;
            e.preventDefault();
            const clientX = e.pageX || (e.touches && e.touches[0] ? e.touches[0].pageX : 0);
            const x = clientX - this.$refs.scrollContainer.offsetLeft;
            const walk = (x - this.startX) * 1.5; // Scroll speed factor
            this.$refs.scrollContainer.scrollLeft = this.scrollLeft - walk;
        },
        exportExcelDetail() {
            this.generateExcel(this.selectedProducer, this.detailData);
        },
        exportDirectExcel(item) {
            const params = {
                CardCode: item.CardCode.substring(1),
                TaxDate: new Date().toISOString().split('T')[0],
            };
            this.loadingCalculate = true;
            _TasProducerDebtReportService.detail(params, this.$fun.getUserID()).then((result) => {
                if (result.status == 200) {
                    if (result.data && result.data.length > 0) {
                        this.generateExcel(item, result.data);
                    } else {
                        this.$fun.alert("No hay movimientos registrados para este productor.", "warning");
                    }
                } else {
                    this.$fun.alert("No se pudieron cargar los datos del productor.", "error");
                }
            }).catch((error) => {
                console.error("Error fetching detail for direct export:", error);
                this.$fun.alert("Ocurrió un error al cargar el detalle de deudas.", "error");
            }).finally(() => {
                this.loadingCalculate = false;
            });
        },

        async exportHistoryExcel(item) {
            try {
                this.loadingCalculate = true;
                this.$fun.alert("Cargando y procesando el histórico...", "info");

                const cardCode = item.CardCode || "";
                const isPP = cardCode.toUpperCase().startsWith("PP");
                const isCP = cardCode.toUpperCase().startsWith("CP");
                let summaryData = [];

                const params = {
                    filter: { CardCode: cardCode },
                    draw: 1,
                    start: 0,
                    length: -1,
                    searchText: ""
                };

                let serviceCall;
                if (isCP) {
                    serviceCall = _TasProducerHistoryRecordService.paginationAdvanceSupplies(params, this.$fun.getUserID());
                } else {
                    serviceCall = _TasProducerHistoryRecordService.paginationAdvanceMoney(params, this.$fun.getUserID());
                }

                const res = await serviceCall;
                let rawData = [];
                if (res && res.status === 200 && res.data) {
                    rawData = Array.isArray(res.data.data) ? res.data.data : (Array.isArray(res.data) ? res.data : []);
                }

                console.log(JSON.parse(JSON.stringify({ rawData })))

                const summaryRes = await _TasProducerHistoryRecordService.liquidationSummaryByProducer({ CardCode: item.CardCode }, this.$fun.getUserID());

                if (summaryRes && summaryRes.status === 200 && summaryRes.data) {
                    summaryData = Array.isArray(summaryRes.data) ? summaryRes.data : [];
                    console.log(JSON.parse(JSON.stringify({ summaryData })))
                }

                if (summaryData.length === 0 && rawData.length === 0) {
                    this.$fun.alert("No se encontraron registros para exportar.", "warning");
                    return;
                }

                const parseDateVal = (dateVal) => {
                    if (!dateVal) return null;
                    try {
                        let dateStr = dateVal.toString().trim();
                        if (dateStr.includes("Date(")) {
                            const ms = dateStr.replace(/\/Date\((\d+)\)\//, '$1');
                            return new Date(Number(ms));
                        }
                        const d = new Date(dateVal);
                        if (!isNaN(d.getTime())) {
                            return d;
                        }
                    } catch (e) { }
                    return null;
                };

                const formatWeekLabel = (weekStr) => {
                    const trimmed = (weekStr || '').toString().trim();
                    if (!trimmed || trimmed === 'Sin Semana') return '';
                    const parts = trimmed.split('-');
                    if (parts.length === 2) {
                        const weekNum = parts[1].replace(/[wW]/g, '').trim();
                        return weekNum.padStart(2, '0');
                    }
                    if (/^\d+$/.test(trimmed)) {
                        return trimmed.padStart(2, '0');
                    }
                    return trimmed;
                };

                const dataByYear = {};

                // Process summaryData (FACT/LIQ)
                summaryData.forEach(row => {
                    const parsedDate = parseDateVal(row.AccountingDate);
                    const dateStr = parsedDate ? this.$moment(parsedDate).format("DD/MM/YYYY") : "";
                    const year = parsedDate ? parsedDate.getFullYear().toString() : "Otros";

                    let weekStr = "";
                    if (row.Week !== null && row.Week !== undefined && row.Week !== "") {
                        weekStr = row.Week.toString().trim().padStart(2, '0');
                    } else if (row.AccountingDateWeek) {
                        weekStr = row.AccountingDateWeek.toString().trim().padStart(2, '0');
                    } else if (row.AccountingDateWeekYear) {
                        weekStr = formatWeekLabel(row.AccountingDateWeekYear);
                    }

                    const amount = Number(row.TotalML) || 0;

                    if (!dataByYear[year]) {
                        dataByYear[year] = [];
                    }

                    dataByYear[year].push({
                        isSummary: true,
                        dateForSorting: row.AccountingDate,
                        weekYearForSorting: row.AccountingDateWeekYear || row.DateWeekYear,
                        data: {
                            fechaCosecha: dateStr,
                            semana: weekStr,
                            codProd: item.CardCode || "",
                            nomProd: item.CardName || "",
                            gCosecha: row.HarvestGuide || "",
                            gre: row.GuideNumber || "",
                            nJabas: row.RealCrates !== null && row.RealCrates !== undefined ? row.RealCrates : (row.Crates || ""),
                            glosa: row.FactLiq || "",
                            transType: "",
                            typeDocumentName: row.DocType || row.FactLiq || "",
                            guiaRemision: row.ReferralGuide || "",
                            monedaLocal: amount
                        }
                    });
                });

                // Process rawData (Advances / Supplies)
                rawData.forEach(row => {
                    const transTypeVal = Number(row.TransType);
                    if (transTypeVal !== 30 && transTypeVal !== 321) {
                        return; // Skip if TransType is not 18 or 321
                    }

                    const parsedDate = parseDateVal(row.AccountingDate);
                    const dateStr = parsedDate ? this.$moment(parsedDate).format("DD/MM/YYYY") : "";
                    const year = parsedDate ? parsedDate.getFullYear().toString() : "Otros";

                    let weekStr = "";
                    if (row.AccountingDateWeekYear) {
                        weekStr = formatWeekLabel(row.AccountingDateWeekYear);
                    }

                    let amount = Number(row.AmountML) || 0;
                    if (row.DebitCreditMS === 'C' || row.DebitCreditML === 'C') {
                        amount = -Math.abs(amount);
                    } else {
                        amount = Math.abs(amount);
                    }
                    if (row.DebitML !== 0 || row.CreditML !== 0) {
                        amount = (row.DebitML || 0) - (row.CreditML || 0);
                    }

                    if (!dataByYear[year]) {
                        dataByYear[year] = [];
                    }

                    dataByYear[year].push({
                        isSummary: false,
                        dateForSorting: row.AccountingDate,
                        weekYearForSorting: row.AccountingDateWeekYear,
                        data: {
                            fechaCosecha: dateStr,
                            semana: weekStr,
                            codProd: item.CardCode || "",
                            nomProd: item.CardName || "",
                            gCosecha: "",
                            gre: "",
                            nJabas: "",
                            glosa: row.Glosa || "",
                            transType: row.TransType || "",
                            typeDocumentName: row.TypeDocumentName || "",
                            guiaRemision: "",
                            monedaLocal: amount
                        }
                    });
                });

                // Sorting helper
                const getSortValue = (item) => {
                    let timestamp = 0;
                    const parsedDate = parseDateVal(item.dateForSorting);
                    if (parsedDate) {
                        timestamp = parsedDate.getTime();
                    }
                    let sortWeekValue = 0;
                    const wStr = (item.weekYearForSorting || '').toString().trim();
                    if (wStr) {
                        const parts = wStr.split('-');
                        if (parts.length === 2) {
                            const yr = parseInt(parts[0]) || 0;
                            const wk = parseInt(parts[1].replace(/[wW]/g, '')) || 0;
                            sortWeekValue = yr * 100 + wk;
                        }
                    }
                    if (sortWeekValue === 0 && timestamp > 0) {
                        const d = new Date(timestamp);
                        const yr = d.getFullYear();
                        const oneJan = new Date(yr, 0, 1);
                        const numberOfDays = Math.floor((d - oneJan) / (24 * 60 * 60 * 1000));
                        const wk = Math.ceil((numberOfDays + oneJan.getDay() + 1) / 7);
                        sortWeekValue = yr * 100 + wk;
                    }
                    return { timestamp, sortWeekValue };
                };

                // Excel Generation
                const workbook = new ExcelJS.Workbook();
                const years = Object.keys(dataByYear).sort((a, b) => a.localeCompare(b));

                years.forEach(year => {
                    const worksheet = workbook.addWorksheet(year, {
                        properties: { tabColor: { argb: "FF1F4E78" } }
                    });

                    // Sort items of this year by week and date
                    const listData = dataByYear[year];
                    listData.sort((a, b) => {
                        const aDate = parseDateVal(a.dateForSorting);
                        const bDate = parseDateVal(b.dateForSorting);
                        const aTime = aDate ? aDate.getTime() : 0;
                        const bTime = bDate ? bDate.getTime() : 0;

                        if (aTime !== bTime) {
                            return aTime - bTime;
                        }

                        const aW = parseInt(a.data.semana) || 0;
                        const bW = parseInt(b.data.semana) || 0;
                        if (aW !== bW) {
                            return aW - bW;
                        }

                        if (a.isSummary && !b.isSummary) return -1;
                        if (!a.isSummary && b.isSummary) return 1;
                        return 0;
                    });

                    // Title Banner
                    const titleRow = worksheet.getRow(2);
                    titleRow.height = 24;
                    const titleCell = titleRow.getCell(1);
                    titleCell.value = `HISTORIAL DETALLADO POR SEMANAS - AÑO ${year} - ${item.CardName}`;
                    titleCell.font = { name: "Calibri", size: 12, bold: true, color: { argb: "FFFFFFFF" } };
                    titleCell.alignment = { vertical: "middle", horizontal: "center" };
                    worksheet.mergeCells(2, 1, 2, 11);

                    for (let col = 1; col <= 11; col++) {
                        const cell = titleRow.getCell(col);
                        cell.fill = {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: { argb: "FF1F4E78" }
                        };
                    }

                    // Subtitle
                    const subtitleRow = worksheet.getRow(3);
                    subtitleRow.height = 18;
                    const subtitleCell = subtitleRow.getCell(1);
                    subtitleCell.value = `Generado: ${this.$moment().format("DD/MM/YYYY HH:mm")} | Proveedor: ${item.CardCode} | Consolidado de Liquidaciones y Anticipos/Insumos`;
                    subtitleCell.font = { name: "Calibri", size: 9, italic: true, color: { argb: "FF555555" } };
                    subtitleCell.alignment = { vertical: "middle", horizontal: "center" };
                    worksheet.mergeCells(3, 1, 3, 11);

                    // Headers Config
                    const headerRow = worksheet.getRow(5);
                    headerRow.height = 28;

                    const headers = [
                        { name: "FECHA COSECHA", width: 16, align: "center" },
                        { name: "SEMANA", width: 14, align: "center" },
                        { name: "COD. PROD", width: 14, align: "center" },
                        { name: "NOM. PROD", width: 35, align: "left" },
                        { name: "G. COSECHA", width: 16, align: "center" },
                        { name: "N° JABAS", width: 12, align: "center" },
                        { name: "GUÍA DE REMISIÓN", width: 20, align: "center" },
                        { name: "GLOSA", width: 45, align: "left" },
                        { name: "TRANSTYPE", width: 12, align: "center" },
                        { name: "TIPO DE DOCUMENTO", width: 25, align: "left" },
                        { name: "MONEDA LOCAL", width: 18, align: "right" }
                    ];

                    headers.forEach((h, idx) => {
                        const colIdx = idx + 1;
                        const cell = headerRow.getCell(colIdx);
                        cell.value = h.name;
                        cell.font = { name: "Calibri", size: 9, bold: true, color: { argb: "FFFFFFFF" } };
                        cell.fill = {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: { argb: "FF4F81BD" }
                        };
                        cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
                        cell.border = {
                            top: { style: "thin", color: { argb: "FF000000" } },
                            bottom: { style: "medium", color: { argb: "FF000000" } },
                            left: { style: "thin", color: { argb: "FFD3D3D3" } },
                            right: { style: "thin", color: { argb: "FFD3D3D3" } }
                        };
                        worksheet.getColumn(colIdx).width = h.width;
                    });

                    // Write Data
                    let currentRowIdx = 6;
                    listData.forEach((rowItem) => {
                        const rowData = rowItem.data;
                        const row = worksheet.addRow([
                            rowData.fechaCosecha,
                            rowData.semana,
                            rowData.codProd,
                            rowData.nomProd,
                            rowData.gCosecha,
                            rowData.nJabas,
                            rowData.guiaRemision,
                            rowData.glosa,
                            rowData.transType,
                            rowData.typeDocumentName,
                            rowData.monedaLocal
                        ]);
                        row.height = 20;

                        const isEven = (currentRowIdx % 2 === 0);
                        const bgArgb = isEven ? "FFF9FBFD" : "FFFFFFFF"; // Clean slate-themed alternate row background

                        row.eachCell((cell, colIdx) => {
                            cell.font = { name: "Calibri", size: 9 };
                            cell.fill = {
                                type: "pattern",
                                pattern: "solid",
                                fgColor: { argb: bgArgb }
                            };
                            cell.border = {
                                top: { style: "thin", color: { argb: "FFE0E0E0" } },
                                bottom: { style: "thin", color: { argb: "FFE0E0E0" } },
                                left: { style: "thin", color: { argb: "FFE0E0E0" } },
                                right: { style: "thin", color: { argb: "FFE0E0E0" } }
                            };

                            const hInfo = headers[colIdx - 1];
                            cell.alignment = { vertical: "middle", horizontal: hInfo.align };

                            if (colIdx === 6) {
                                if (cell.value !== "" && cell.value !== null && cell.value !== undefined) {
                                    cell.numFmt = "#,##0";
                                }
                            } else if (colIdx === 11) {
                                cell.numFmt = "#,##0.00";
                            }
                        });

                        currentRowIdx++;
                    });

                    // Totals Row
                    const totalsRowIdx = currentRowIdx;
                    const totalsRow = worksheet.addRow([]);
                    totalsRow.height = 24;

                    for (let colIdx = 1; colIdx <= 11; colIdx++) {
                        const cell = totalsRow.getCell(colIdx);
                        cell.border = {
                            top: { style: "thin", color: { argb: "FFB0B0B0" } },
                            bottom: { style: "double", color: { argb: "FF000000" } },
                            left: { style: "thin", color: { argb: "FFE0E0E0" } },
                            right: { style: "thin", color: { argb: "FFE0E0E0" } }
                        };
                        cell.fill = {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: { argb: "FFF9F9F9" }
                        };
                    }

                    const labelCell = totalsRow.getCell(1);
                    labelCell.value = "TOTAL GENERAL";
                    labelCell.font = { name: "Calibri", size: 9, bold: true };
                    labelCell.alignment = { vertical: "middle", horizontal: "left" };
                    worksheet.mergeCells(`A${totalsRowIdx}:E${totalsRowIdx}`);

                    const cratesCell = totalsRow.getCell(6);
                    cratesCell.value = { formula: `SUM(F6:F${totalsRowIdx - 1})` };
                    cratesCell.font = { name: "Calibri", size: 9, bold: true };
                    cratesCell.numFmt = "#,##0";
                    cratesCell.alignment = { vertical: "middle", horizontal: "center" };

                    const totalMLCell = totalsRow.getCell(11);
                    totalMLCell.value = { formula: `SUM(K6:K${totalsRowIdx - 1})` };
                    totalMLCell.font = { name: "Calibri", size: 9, bold: true };
                    totalMLCell.numFmt = "#,##0.00";
                    totalMLCell.alignment = { vertical: "middle", horizontal: "right" };

                    worksheet.views = [
                        {
                            state: "frozen",
                            ySplit: 5,
                            zoomScale: 100,
                            showGridLines: true
                        }
                    ];
                });

                const buffer = await workbook.xlsx.writeBuffer();
                const filename = `Historial_Semanas_${item.CardCode}_${item.CardName.replace(/[^a-zA-Z0-9]/g, '_')}_${new Date().getTime()}.xlsx`;
                saveAs(new Blob([buffer]), filename);
                this.$fun.alert("Historial detallado exportado correctamente.", "success");
            } catch (error) {
                console.error("Error exporting consolidated history:", error);
                this.$fun.alert("Ocurrió un error al generar la exportación del histórico.", "error");
            } finally {
                this.loadingCalculate = false;
            }
        },

        async exportExcel() {
            if (!this.$refs.crudproducerdebt) return;
            try {
                this.loadingExportMain = true;

                const params = {
                    filter: { ShowDebtors: 1 },
                    draw: 1,
                    start: 0,
                    length: -1,
                    searchText: ""
                };

                const response = await _TasProducerDebtReportService.pagination(params, this.$fun.getUserID());
                if (response.status !== 200 || !response.data || !response.data.data) {
                    this.$fun.alert("No se pudieron obtener los datos para la exportación.", "error");
                    return;
                }

                const data = response.data.data;
                if (data.length === 0) {
                    this.$fun.alert("No hay registros para exportar con los filtros actuales.", "warning");
                    return;
                }

                // Group data by TypeDebt
                const groups = {};
                data.forEach(item => {
                    const type = (item.TypeDebt || 'OTROS').trim().toUpperCase();
                    if (!groups[type]) {
                        groups[type] = [];
                    }
                    groups[type].push(item);
                });

                const workbook = new ExcelJS.Workbook();

                const colLetter = (idx) => {
                    let temp = idx;
                    let letter = "";
                    while (temp > 0) {
                        let modulo = (temp - 1) % 26;
                        letter = String.fromCharCode(65 + modulo) + letter;
                        temp = Math.floor((temp - modulo) / 26);
                    }
                    return letter;
                };

                Object.keys(groups).forEach(type => {
                    const groupData = groups[type];
                    // Sheet name must be less than 31 characters and cannot contain special characters
                    let sheetName = type.substring(0, 30).replace(/[*?:\\/\[\]]/g, '');
                    if (!sheetName) sheetName = 'OTROS';

                    const worksheet = workbook.addWorksheet(sheetName, {
                        properties: { tabColor: { argb: "FF1F4E78" } }
                    });

                    // Column structures
                    worksheet.columns = [
                        { header: "Código Proveedor", key: "CardCode", width: 18 },
                        { header: "Proveedor", key: "CardName", width: 45 },
                        { header: "Grupo", key: "GroupName", width: 22 },
                        { header: "Tipo Proveedor", key: "CardTypeName", width: 18 },
                        { header: "Total (USD)", key: "BalanceME", width: 18 },
                        { header: "Total (Soles)", key: "BalanceML", width: 18 }
                    ];

                    // Format headers
                    const headerRow = worksheet.getRow(1);
                    headerRow.height = 28;
                    headerRow.eachCell((cell) => {
                        cell.fill = {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: { argb: "FF1F4E78" }
                        };
                        cell.font = {
                            name: "Calibri",
                            size: 10,
                            bold: true,
                            color: { argb: "FFFFFFFF" }
                        };
                        cell.alignment = {
                            vertical: "middle",
                            horizontal: "center",
                            wrapText: true
                        };
                        cell.border = {
                            top: { style: "thin", color: { argb: "FFD3D3D3" } },
                            left: { style: "thin", color: { argb: "FFD3D3D3" } },
                            bottom: { style: "thin", color: { argb: "FFD3D3D3" } },
                            right: { style: "thin", color: { argb: "FFD3D3D3" } }
                        };
                    });

                    // Add records
                    groupData.forEach((rowItem) => {
                        const rowData = {
                            CardCode: rowItem.CardCode,
                            CardName: rowItem.CardName,
                            GroupName: rowItem.GroupName,
                            CardTypeName: rowItem.CardTypeName,
                            BalanceME: rowItem.BalanceME != null ? Math.abs(Number(rowItem.BalanceME)) : 0,
                            BalanceML: rowItem.BalanceML != null ? Math.abs(Number(rowItem.BalanceML)) : 0
                        };

                        const row = worksheet.addRow(rowData);
                        row.height = 20;

                        row.eachCell((cell, colIdx) => {
                            cell.font = { name: "Calibri", size: 9 };
                            cell.border = {
                                top: { style: "thin", color: { argb: "FFE0E0E0" } },
                                left: { style: "thin", color: { argb: "FFE0E0E0" } },
                                bottom: { style: "thin", color: { argb: "FFE0E0E0" } },
                                right: { style: "thin", color: { argb: "FFE0E0E0" } }
                            };

                            if ([1, 3, 4].includes(colIdx)) {
                                cell.alignment = { vertical: "middle", horizontal: "center" };
                            } else if ([5, 6].includes(colIdx)) {
                                cell.numFmt = "#,##0.00";
                                cell.alignment = { vertical: "middle", horizontal: "right" };
                            } else {
                                cell.alignment = { vertical: "middle", horizontal: "left" };
                            }
                        });
                    });

                    // Add total summary row
                    const totalsRow = worksheet.addRow([]);
                    totalsRow.height = 24;
                    const labelCell = totalsRow.getCell(1);
                    labelCell.value = "TOTAL GENERAL";
                    labelCell.font = { name: "Calibri", size: 9, bold: true };
                    labelCell.alignment = { vertical: "middle", horizontal: "left" };

                    // Merge cells for the label from column 1 to 4
                    worksheet.mergeCells(`A${totalsRow.number}:D${totalsRow.number}`);

                    for (let colIdx = 1; colIdx <= worksheet.columns.length; colIdx++) {
                        const cell = totalsRow.getCell(colIdx);
                        cell.border = {
                            top: { style: "thin", color: { argb: "FFB0B0B0" } },
                            left: { style: "thin", color: { argb: "FFB0B0B0" } },
                            bottom: { style: "double", color: { argb: "FF000000" } },
                            right: { style: "thin", color: { argb: "FFB0B0B0" } }
                        };

                        if ([5, 6].includes(colIdx)) {
                            const letter = colLetter(colIdx);
                            const dataStart = 2;
                            const dataEnd = groupData.length + 1;
                            cell.value = { formula: `SUM(${letter}${dataStart}:${letter}${dataEnd})` };
                            cell.font = { name: "Calibri", size: 9, bold: true };
                            cell.numFmt = "#,##0.00";
                            cell.alignment = { vertical: "middle", horizontal: "right" };
                        }
                    }

                    // Auto filter and views
                    worksheet.autoFilter = {
                        from: { row: 1, column: 1 },
                        to: { row: 1, column: worksheet.columns.length }
                    };

                    worksheet.views = [
                        {
                            state: "frozen",
                            ySplit: 1, // Freeze header row
                            zoomScale: 100,
                            showGridLines: true
                        }
                    ];
                });

                const buffer = await workbook.xlsx.writeBuffer();
                const filename = `Reporte_Deuda_Productores_Agrupado_${new Date().getTime()}.xlsx`;
                saveAs(new Blob([buffer]), filename);
                this.$fun.alert("Archivo Excel agrupado generado y descargado correctamente.", "success");
            } catch (error) {
                console.error("Error generating main Excel:", error);
                this.$fun.alert("Ocurrió un error al generar el reporte Excel.", "error");
            } finally {
                this.loadingExportMain = false;
            }
        },
        async generateExcel(selectedProducer, detailData) {
            if (!detailData || detailData.length === 0) return;
            try {
                this.$fun.alert("Generando Excel de detalle...", "info");

                const workbook = new ExcelJS.Workbook();
                const sheetName = "Historial de Deudas";
                const worksheet = workbook.addWorksheet(sheetName, {
                    properties: { tabColor: { argb: "FF1F4E78" } }
                });

                // Column structures
                worksheet.columns = [
                    { header: "Fecha", key: "AccountingDate", width: 15 },
                    { header: "Tipo Documento", key: "DocumentType", width: 25 },
                    { header: "Glosa / Concepto", key: "Glosa", width: 50 },
                    { header: "Monto (USD)", key: "AmountME", width: 18 },
                    { header: "Monto (Soles)", key: "AmountML", width: 18 },
                    { header: "Tipo Deuda", key: "TypeDebt", width: 18 }
                ];

                // Format headers
                const headerRow = worksheet.getRow(1);
                headerRow.height = 28;
                headerRow.eachCell((cell) => {
                    cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FF1F4E78" }
                    };
                    cell.font = {
                        name: "Calibri",
                        size: 10,
                        bold: true,
                        color: { argb: "FFFFFFFF" }
                    };
                    cell.alignment = {
                        vertical: "middle",
                        horizontal: "center",
                        wrapText: true
                    };
                    cell.border = {
                        top: { style: "thin", color: { argb: "FFD3D3D3" } },
                        left: { style: "thin", color: { argb: "FFD3D3D3" } },
                        bottom: { style: "thin", color: { argb: "FFD3D3D3" } },
                        right: { style: "thin", color: { argb: "FFD3D3D3" } }
                    };
                });

                // Add records
                detailData.forEach((rowItem) => {
                    const rowData = {
                        AccountingDate: rowItem.AccountingDate ? this.$moment(rowItem.AccountingDate).format("DD/MM/YYYY") : "",
                        DocumentType: rowItem.DocumentType,
                        Glosa: rowItem.Glosa,
                        AmountME: rowItem.AmountME != null ? Math.abs(Number(rowItem.AmountME)) : 0,
                        AmountML: rowItem.AmountML != null ? Math.abs(Number(rowItem.AmountML)) : 0,
                        TypeDebt: rowItem.TypeDebt
                    };

                    const row = worksheet.addRow(rowData);
                    row.height = 20;

                    row.eachCell((cell, colIdx) => {
                        cell.font = { name: "Calibri", size: 9 };
                        cell.border = {
                            top: { style: "thin", color: { argb: "FFE0E0E0" } },
                            left: { style: "thin", color: { argb: "FFE0E0E0" } },
                            bottom: { style: "thin", color: { argb: "FFE0E0E0" } },
                            right: { style: "thin", color: { argb: "FFE0E0E0" } }
                        };

                        if (colIdx === 1) {
                            cell.alignment = { vertical: "middle", horizontal: "center" };
                        } else if (colIdx === 2) {
                            cell.alignment = { vertical: "middle", horizontal: "center" };
                        } else if ([4, 5].includes(colIdx)) {
                            cell.numFmt = "#,##0.00";
                            cell.alignment = { vertical: "middle", horizontal: "right" };
                        } else if (colIdx === 6) {
                            cell.alignment = { vertical: "middle", horizontal: "center" };
                        } else {
                            cell.alignment = { vertical: "middle", horizontal: "left" };
                        }
                    });
                });

                // Add total summary row
                const totalsRow = worksheet.addRow([]);
                totalsRow.height = 24;
                const labelCell = totalsRow.getCell(1);
                labelCell.value = "TOTAL GENERAL";
                labelCell.font = { name: "Calibri", size: 9, bold: true };
                labelCell.alignment = { vertical: "middle", horizontal: "left" };

                // Merge cells for the label from column 1 to 3
                worksheet.mergeCells(`A${totalsRow.number}:C${totalsRow.number}`);

                const colLetter = (idx) => {
                    let temp = idx;
                    let letter = "";
                    while (temp > 0) {
                        let modulo = (temp - 1) % 26;
                        letter = String.fromCharCode(65 + modulo) + letter;
                        temp = Math.floor((temp - modulo) / 26);
                    }
                    return letter;
                };

                for (let colIdx = 1; colIdx <= worksheet.columns.length; colIdx++) {
                    const cell = totalsRow.getCell(colIdx);
                    cell.border = {
                        top: { style: "thin", color: { argb: "FFB0B0B0" } },
                        left: { style: "thin", color: { argb: "FFB0B0B0" } },
                        bottom: { style: "double", color: { argb: "FF000000" } },
                        right: { style: "thin", color: { argb: "FFB0B0B0" } }
                    };

                    if ([4, 5].includes(colIdx)) {
                        const letter = colLetter(colIdx);
                        const dataStart = 2;
                        const dataEnd = detailData.length + 1;
                        cell.value = { formula: `SUM(${letter}${dataStart}:${letter}${dataEnd})` };
                        cell.font = { name: "Calibri", size: 9, bold: true };
                        cell.numFmt = "#,##0.00";
                        cell.alignment = { vertical: "middle", horizontal: "right" };
                    }
                }

                // Auto filter and views
                worksheet.autoFilter = {
                    from: { row: 1, column: 1 },
                    to: { row: 1, column: worksheet.columns.length }
                };

                worksheet.views = [
                    {
                        state: "frozen",
                        ySplit: 1, // Freeze header row
                        zoomScale: 100,
                        showGridLines: true
                    }
                ];

                const buffer = await workbook.xlsx.writeBuffer();
                const filename = `Detalle_Deuda_${selectedProducer ? selectedProducer.CardCode : 'Productor'}_${new Date().getTime()}.xlsx`;
                saveAs(new Blob([buffer]), filename);
                this.$fun.alert("Archivo Excel generado y descargado correctamente.", "success");
            } catch (error) {
                console.error("Error generating excel:", error);
                this.$fun.alert("Ocurrió un error al generar el archivo Excel.", "error");
            }
        }
    },
};
</script>

<style scoped>
.font-weight-semibold {
    font-weight: 600;
}

.text-green {
    color: #1aa521 !important;
}

.card-code-badge {
    display: inline-block;
    padding: 4px !important;
    /* p-1 */
    border-radius: 8px !important;
    /* rounded-lg */
    font-size: 10px !important;
    /* text10px */
    font-weight: 600 !important;
    line-height: 1 !important;
    background-color: rgba(25, 118, 210, 0.08) !important;
    /* low transparent primary background */
    color: #1976d2 !important;
    /* primary text color */
    border: 1px solid #1976d2 !important;
    /* primary border */
    text-align: center;
    width: fit-content;
}

::v-deep .shadcn-modal-table {
    border: none !important;
}

::v-deep .shadcn-modal-table .v-data-table__wrapper {
    overflow-x: auto;
}

::v-deep .shadcn-modal-table .v-data-table-header th {
    background-color: #fafafa !important;
    font-size: 0.75rem !important;
    font-weight: 600 !important;
    color: #71717a !important;
    height: 40px !important;
    border-bottom: 1px solid #e4e4e7 !important;
    padding: 0 16px !important;
    white-space: nowrap;
}

::v-deep .shadcn-modal-table tbody tr:hover {
    background-color: #f8f9fa !important;
}

::v-deep .shadcn-modal-table tbody td {
    font-size: 0.8125rem !important;
    border-bottom: 1px solid #f4f4f5 !important;
    padding: 8px 16px !important;
}

::v-deep .shadcn-modal-table .v-data-footer {
    border-top: 1px solid #e4e4e7 !important;
    padding: 8px 16px !important;
    background-color: #ffffff !important;
}

.doc-type-badge {
    display: inline-block;
    padding: 4px 8px !important;
    /* p-1 px-2 */
    border-radius: 8px !important;
    /* rounded-lg */
    font-size: 10px !important;
    /* text-10px */
    font-weight: 600 !important;
    line-height: 1 !important;
    background-color: rgba(113, 113, 122, 0.08) !important;
    /* fondo semitransparente gris */
    color: #52525b !important;
    /* texto gris oscuro */
    border: 1px solid #d4d4d8 !important;
    /* border gris */
    text-align: center;
    width: fit-content;
    white-space: nowrap;
}

.type-debt-badge-magenta {
    display: inline-block;
    padding: 4px 8px !important;
    border-radius: 8px !important;
    font-size: 10px !important;
    font-weight: 600 !important;
    line-height: 1 !important;
    background-color: rgba(217, 70, 239, 0.08) !important;
    color: #a21caf !important;
    border: 1px solid #d946ef !important;
    text-align: center;
    width: fit-content;
    white-space: nowrap;
}

.type-debt-badge-green {
    display: inline-block;
    padding: 4px 8px !important;
    border-radius: 8px !important;
    font-size: 10px !important;
    font-weight: 600 !important;
    line-height: 1 !important;
    background-color: rgba(34, 197, 94, 0.08) !important;
    color: #16a34a !important;
    border: 1px solid #22c55e !important;
    text-align: center;
    width: fit-content;
    white-space: nowrap;
}

.type-debt-badge-gray {
    display: inline-block;
    padding: 4px 8px !important;
    border-radius: 8px !important;
    font-size: 10px !important;
    font-weight: 600 !important;
    line-height: 1 !important;
    background-color: rgba(113, 113, 122, 0.08) !important;
    color: #52525b !important;
    border: 1px solid #d4d4d8 !important;
    text-align: center;
    width: fit-content;
    white-space: nowrap;
}

.double-timeline-wrapper {
    position: relative;
    width: 100%;
    overflow-x: auto;
    padding-top: 16px;
    padding-bottom: 16px;
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 #f1f5f9;
}

.dashboard-3d-row {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    cursor: grab;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 #f1f5f9;
}

.dashboard-3d-row.dragging {
    cursor: grabbing;
}

.dashboard-3d-row::-webkit-scrollbar {
    height: 6px;
}

.dashboard-3d-row::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
}

.dashboard-3d-row::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
}

.dashboard-3d-card {
    flex: 0 0 210px;
    width: 210px;
    background: #ffffff;
    border: 1px solid #e4e4e7;
    border-radius: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
}

.dashboard-3d-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.04);
}

.dashboard-year-badge {
    background: #f1f5f9;
    color: #475569;
    font-size: 11px !important;
    font-weight: 800;
    padding: 2px 8px;
    border-radius: 9999px;
    border: 1px solid #e2e8f0;
}

.chart-bar-area {
    position: relative;
    height: 200px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #f1f5f9;
    padding: 4px;
    overflow: hidden;
}

.chart-canvas-container {
    position: relative;
    height: 100%;
    width: 100%;
}

.legend-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
}

.legend-dot.orange {
    background-color: #f97316;
}

.legend-dot.green {
    background-color: #22c55e;
}

.dashboard-card-details {
    border-top: 1px solid #f1f5f9;
}

.elegant-switch-container {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #ffffff;
    border: 1px solid #e4e4e7;
    padding: 6px 14px;
    border-radius: 12px;
    cursor: pointer;
    user-select: none;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    max-width: fit-content;
}

.elegant-switch-container:hover {
    border-color: #cbd5e1;
    background: #fafafa;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.elegant-switch-container:active {
    transform: scale(0.98);
}

.elegant-switch-container.active {
    border-color: rgba(25, 118, 210, 0.25);
    background: rgba(25, 118, 210, 0.03);
}

.elegant-switch-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: #f4f4f5;
    transition: all 0.3s ease;
}

.elegant-switch-container.active .elegant-switch-icon {
    background: rgba(25, 118, 210, 0.08);
}

.elegant-switch-text {
    display: flex;
    flex-direction: column;
    line-height: 1.25;
}

.elegant-switch-label {
    font-size: 10px;
    font-weight: 700;
    color: #475569;
    letter-spacing: 0.3px;
    transition: all 0.3s ease;
}

.elegant-switch-container.active .elegant-switch-label {
    color: #1565c0;
}

.elegant-switch-status {
    font-size: 9px;
    font-weight: 600;
    color: #94a3b8;
    text-transform: uppercase;
    transition: all 0.3s ease;
}

.elegant-switch-container.active .elegant-switch-status {
    color: #1976d2;
}

.elegant-switch-toggle {
    position: relative;
    width: 32px;
    height: 18px;
    background-color: #e4e4e7;
    border-radius: 9999px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    margin-left: 4px;
}

.elegant-switch-container.active .elegant-switch-toggle {
    background-color: #1976d2;
}

.elegant-switch-knob {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 14px;
    height: 14px;
    background-color: #ffffff;
    border-radius: 50%;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.elegant-switch-container.active .elegant-switch-knob {
    transform: translateX(14px);
}

.bg-slate-50 {
    background-color: #f8fafc !important;
}

.text-slate-800 {
    color: #1e293b !important;
}

.text-slate-700 {
    color: #334155 !important;
}

.text-slate-600 {
    color: #475569 !important;
}

.text-slate-500 {
    color: #64748b !important;
}

.header-icon-container {
    width: 28px;
    height: 28px;
    border-radius: 8px;
}

.bg-amber-light {
    background-color: #fef3c7 !important;
}

.bg-emerald-light {
    background-color: #d1fae5 !important;
}

.doc-type-pill {
    display: inline-block;
    padding: 2px 8px !important;
    border-radius: 6px !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    background-color: #f1f5f9 !important;
    color: #475569 !important;
    border: 1px solid #e2e8f0 !important;
    white-space: nowrap;
}

.tailwind-styled-table ::v-deep table thead th {
    background-color: #f8fafc !important;
    color: #475569 !important;
    font-size: 11px !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.05em !important;
    border-bottom: 1px solid #e2e8f0 !important;
}

.tailwind-styled-table ::v-deep table tbody tr {
    transition: background-color 0.15s ease-in-out;
}

.tailwind-styled-table ::v-deep table tbody tr:hover {
    background-color: #f1f5f9 !important;
}

.tailwind-styled-table ::v-deep table tbody td {
    border-bottom: 1px solid #f1f5f9 !important;
    font-size: 12px !important;
}
</style>
